import type { Export, ExportRequest, ShareExport, ShareExportRequest } from '@/types/export';
import { exportSchema, shareExportSchema } from '@/types/export';
import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';

const BASE = `${INTERNAL_V1}/exports`;

export const createExport = async (params: ExportRequest, token?: string): Promise<Export> => {
  const response = await damRequest('POST', BASE, token, { body: params });
  return exportSchema.parse(response);
};

export const getExport = async ({ id }: { id: string }, token?: string): Promise<Export> => {
  const response = await damRequest('GET', `${BASE}/${id}`, token);
  return exportSchema.parse(response);
};

export const createShareExport = async (
  shareId: string,
  params: ShareExportRequest,
  token?: string,
): Promise<ShareExport> => {
  const response = await damRequest('POST', `${INTERNAL_V1}/shares/${shareId}/exports`, token, { body: params });
  return shareExportSchema.parse(response);
};

export const getShareExport = async (
  { shareId, id }: { shareId: string; id: string },
  token?: string,
): Promise<ShareExport> => {
  const response = await damRequest('GET', `${INTERNAL_V1}/shares/${shareId}/exports/${id}`, token);
  return shareExportSchema.parse(response);
};
